import SearchIcon from "@hub/assets/search-icon.svg";
import { useLabFiltering } from "@hub/services/use-lab-filtering";
import React, { useState } from "react";
import styles from "./search-bar.module.css";

interface LabsSearchBarProps {
  placeholderMessage?: string;
  enableFilter?: boolean;
}

export const LabsSearchBar: React.FC<LabsSearchBarProps> = ({
  placeholderMessage,
}) => {
  const [searchValue, setSearchValue] = useState("");

  const { setSearchTermFilter } = useLabFiltering();

  const handleSearchValueChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value: nextValue } = event.target;

    setSearchValue(nextValue);

    setSearchTermFilter(nextValue);
  };

  return (
    <div className={styles.searchBar__wrapper}>
      <input
        onChange={handleSearchValueChange}
        className={styles.searchBar}
        placeholder={placeholderMessage || "Search labs"}
        value={searchValue}
      />
      <div className={styles.searchBar__icon}>
        <SearchIcon />
      </div>
    </div>
  );
};
